import { get, post } from "../../services/HttpService";

export class BmcApiService {
  static fetchOutstanding = (queryData = {}, config = {}) => {
    return post(`bmc_mumbai/fetch-outstanding/`, queryData, config).catch((error) => ({
      success: false,
      data: error?.response?.data ?? {},
      message: error?.response?.data?.message ?? "Request failed",
    }));
  };

  static initiatePayment = (queryData = {}, config = {}) => {
    return post(`bmc_mumbai/initiate-payment/`, queryData, config).catch((error) => ({
      success: false,
      data: error?.response?.data ?? {},
      message: error?.response?.data?.message ?? "Request failed",
    }));
  };

  static getTransactionDetails = (txnId, config = {}) => {
    return get(`bmc_mumbai/transaction-details/`, { txn_id: txnId }, config).catch((error) => ({
      success: false,
      data: error?.response?.data ?? {},
      message: error?.response?.data?.message ?? "Request failed",
    }));
  };

  static resolveLink = (token, year, month, date, config = {}) => {
    return post(`bmc_mumbai/resolve-link/`, { token, year, month, date }, config).catch((error) => ({
      success: false,
      message: error?.response?.data?.message ?? "Request failed",
    }));
  };

  static getReceiptInfo = (ebzPayId, config = {}) => {
    return get(`bmc_mumbai/receipt-info/`, { ebz_pay_id: ebzPayId }, config).catch((error) => ({
      success: false,
      message: error?.response?.data?.message ?? "Request failed",
    }));
  };
}
